/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';

import LoginSupportSection from './LoginSupportSection';
import messages from 'src/shared/app/authentication/l10n/authenticationSupportL10n';
import DocumentTitle from 'src/shared/app/base/component/document/DocumentTitle';

type Props = {
  isUsernameRetrievalAllowed: boolean,
  isLoginLinkDisabled: boolean,
};

const LoginSupportMainDumb = ({
  isUsernameRetrievalAllowed,
  isLoginLinkDisabled,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <DocumentTitle>
        {intl.formatMessage(messages.loginSupportTitle)}
      </DocumentTitle>
      <LoginSupportSection
        isUsernameRetrievalAllowed={isUsernameRetrievalAllowed}
        isLoginLinkDisabled={isLoginLinkDisabled}
      />
    </React.Fragment>
  );
};

export default compose(React.memo)(LoginSupportMainDumb);
